/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetFragmentsListByIdQueryResponse, GetFragmentsListByIdPathParams, GetFragmentsListById404 } from "../models/GetFragmentsListById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getFragmentsListById } from "../axios/getFragmentsListById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getFragmentsListByIdQueryKey = (id: GetFragmentsListByIdPathParams["id"]) => ["web-app-bff-api", { url: '/fragments/:id', params: {id:id} }] as const

export type GetFragmentsListByIdQueryKey = ReturnType<typeof getFragmentsListByIdQueryKey>

export function getFragmentsListByIdQueryOptions(id: GetFragmentsListByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getFragmentsListByIdQueryKey(id)
        return queryOptions<GetFragmentsListByIdQueryResponse, ResponseErrorConfig<GetFragmentsListById404>, GetFragmentsListByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getFragmentsListById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get one fragment by id with poster, social upload statuses and external delivery status
 * {@link /fragments/:id}
 */
export function useGetFragmentsListById<TData = GetFragmentsListByIdQueryResponse, TQueryData = GetFragmentsListByIdQueryResponse, TQueryKey extends QueryKey = GetFragmentsListByIdQueryKey>(id: GetFragmentsListByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetFragmentsListByIdQueryResponse, ResponseErrorConfig<GetFragmentsListById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getFragmentsListByIdQueryKey(id)
         

         const query = useQuery({
          ...getFragmentsListByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetFragmentsListById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}